import { useState } from 'react';
import { Checkbox } from '@mui/material';
import Button from './Button';

import './ConfirmationWarningCheckbox.scss';

const ConfirmationWarningCheckbox = ({
	title,
	subtitle,
	message,
	acceptLabel,
	declineLabel,
	onAccept,
	onDecline
}) => {
	const [checked, setChecked] = useState(false);
	console.log(checked);
	const handleChange = (event) => {
		setChecked(event.target.checked);
	};
	return (
		<>
			<section>
				<header>
					<h2>{title}</h2>
				</header>
			</section>
			<div className='confirmation-Warning-subtitle'>
				<p>{subtitle}</p>
			</div>
			<div className='confirmation-Warning-message'>
				<p>{message}</p>
			</div>
			<div className='confirmation-Warning-checkbox'>
				<Checkbox
					checked={checked}
					onChange={handleChange}
					required
				/>
				<div>Yes, Accept</div>
			</div>
			<footer className='action-confirm-buttons'>
				<Button
					className='primary-button'
					onClick={onAccept}
					disabled={!checked}
				>
					{acceptLabel}
				</Button>
				<Button
					className='secondary-button'
					onClick={onDecline}
				>
					{declineLabel}
				</Button>
			</footer>
		</>
	);
};

export default ConfirmationWarningCheckbox;
